import request from "@/utils/request";

// 发送邮件
export function sendEmailMsg(data) {
  return request({
    url: "/msgMail/sendEmailMsg",
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
  });
}
